<ms-competition-tree class="show-more" [topCompetition]="true" [sport]="sport" [context]="context" (treeItemClicked)="itemClicked($event)" />
